import { Intranet } from 'src/presentation/pages'

export const makeIntranet = () => <Intranet />
